import React, { useState } from "react";
import dayjs from "dayjs";

import { styled } from "@mui/material/styles";
import { Box, CardContent, Chip, IconButton, Typography } from "@mui/material";

import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import AttachFileIcon from "@mui/icons-material/AttachFile";

import DialogConfirmWithdraw from "../../shared/general/DialogConfirmWithdraw";
import CardStyled from "../../shared/general/Card";

import StatusRequest from "./statusRequest";

const StyledChip = styled(Chip)({
  backgroundColor: "#ebf5ff",
  color: "#007aff",
  fontSize: 16,
  fontWeight: 500,
  "&.not-approve": {
    backgroundColor: "#EEEEEE",
    color: "#919eab",
  },
});

const StyledWrapChip = styled("div")({
  display: "flex",
  justifyContent: "center",
  margin: "8px 0",
});

const StyledWrapHead = styled("div")({
  display: "flex",
  alignItems: "center",
  "&.approve": {
    justifyContent: "space-between",
  },
  "&.not-approve": {
    justifyContent: "flex-end",
  },
});

const StyledTextDate = styled(Typography)({
  "&.not-approve": {
    color: "#919eab",
    fontStyle: "oblique",
    fontWeight: 400,
  },
});

const CardHistoryLeave = (props) => {
  const {
    data,
    handleDeleteLeave,
    setDataWithDraw,
    // openConfirmDialog,
    // setOpenConfirmDialog,
  } = props;

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const handleClickOpenDialog = () => {
    setDataWithDraw(data);
    setOpenConfirmDialog(true);
  };

  const handleClickCloseDialog = () => {
    setOpenConfirmDialog(false);
  };

  return (
    <div style={{ width: 350, margin: 8 }}>
      <CardStyled>
        <CardContent style={{ padding: 16 }}>
          <StyledWrapHead
            className={data.isApprove !== 0 ? "approve" : "not-approve"}
          >
            <Box display="flex" gap="8px">
              {data.isApprove !== 0 && (
                <IconButton
                  aria-label="delete"
                  size="small"
                  onClick={handleClickOpenDialog}
                >
                  <DeleteOutlineRoundedIcon fontSize="inherit" />
                </IconButton>
              )}
              {data.filename && (
                <IconButton
                  aria-label="delete"
                  size="small"
                  component={"a"}
                  href={data.fileURL}
                  target="_blank"
                >
                  <AttachFileIcon fontSize="inherit" />
                </IconButton>
              )}
            </Box>

            <StatusRequest
              status={data.isApprove ? 1 : data.approveDate ? 2 : 0}
            />
          </StyledWrapHead>
          <StyledWrapChip>
            <StyledChip
              className={data.isApprove === 0 ? "not-approve" : ""}
              label={`${data.name} ${data.used} วัน`}
            />
          </StyledWrapChip>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body2" color="text.secondary">
                เริ่มต้น
              </Typography>
              <StyledTextDate
                className={data.isApprove === 0 ? "not-approve" : ""}
                variant="h6"
              >
                {dayjs(data.startText, "DD/MM/YYYY HH:mm").format("DD/MM/BBBB")}
              </StyledTextDate>
              <StyledTextDate
                className={data.isApprove === 0 ? "not-approve" : ""}
                variant="h6"
                style={{ height: 32 }}
              >
                {dayjs(data.startText, "DD/MM/YYYY HH:mm").format("HH:mm") !=
                "00:00"
                  ? dayjs(data.startText, "DD/MM/YYYY HH:mm").format("HH:mm")
                  : ""}
              </StyledTextDate>
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body2" align="right" color="text.secondary">
                สิ้นสุด
              </Typography>
              <StyledTextDate
                className={data.isApprove === 0 ? "not-approve" : ""}
                variant="h6"
                align="right"
              >
                {dayjs(data.endText, "DD/MM/YYYY HH:mm").format("DD/MM/BBBB")}
              </StyledTextDate>
              <StyledTextDate
                className={data.isApprove === 0 ? "not-approve" : ""}
                variant="h6"
                align="right"
                style={{ height: 32 }}
              >
                {dayjs(data.endText, "DD/MM/YYYY HH:mm").format("HH:mm") !=
                "00:00"
                  ? dayjs(data.endText, "DD/MM/YYYY HH:mm").format("HH:mm")
                  : ""}
              </StyledTextDate>
            </div>
          </div>
          {/* <Divider style={{ margin: "8px" }} /> */}
          {data.holidayName && (
            <div style={{ padding: 8 }}>
              <Typography
                color="text.secondary"
                style={{
                  fontSize: 14,
                  fontStyle: "oblique",
                }}
              >
                {`** ${data.holidayName}`}
              </Typography>
            </div>
          )}

          <div style={{ padding: 8 }}>
            <Typography
              color="text.third"
              style={{
                fontSize: 16,
                fontStyle: "oblique",
              }}
            >
              เหตุผล: {data.description ? data.description : "-"}
            </Typography>
          </div>
        </CardContent>
      </CardStyled>
      <DialogConfirmWithdraw
        mode={"2"}
        open={openConfirmDialog}
        data={data}
        handleClose={handleClickCloseDialog}
        handleDeleteLeave={handleDeleteLeave}
      />
    </div>
  );
};

export default CardHistoryLeave;
